document.addEventListener('DOMContentLoaded', function () {
  // Solid header after scrolling past the hero
  var header = document.getElementById('site-header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.7);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Hero film fallback: if the primary film fails, load the dollhouse film
  var heroVideo = document.getElementById('hero-video');
  if (heroVideo) {
    var primary = heroVideo.querySelector('source[data-primary]');
    heroVideo.addEventListener('error', function () {
      if (primary && !heroVideo.dataset.fallbackUsed) {
        heroVideo.dataset.fallbackUsed = '1';
        primary.src = primary.src.replace('hero-film.mp4', 'dollhouse-film.mp4');
        heroVideo.load();
      }
    }, true);
  }

  // Footer year
  var year = document.getElementById('footer-year');
  if (year) year.textContent = new Date().getFullYear();
});
